"use client";

import { cn } from "@oreme/ui";
import { cva } from "class-variance-authority";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { LabelListItem } from "@/components";
import type { ObservatoryLabel } from "@/types";

interface LabelListProps extends HTMLAttributes<HTMLUListElement> {
  data: ObservatoryLabel[];
}

const labelListVariants = cva("flex flex-col gap-1");

function LabelList({
  className,
  data,
}: Readonly<LabelListProps>): ReactElement {
  return (
    <ul className={cn(labelListVariants({ className }))}>
      {data.map((item): ReactElement => {
        const label = item.label;
        return (
          <li key={label.id}>
            <LabelListItem label={label} />
          </li>
        );
      })}
    </ul>
  );
}

export { LabelList, type LabelListProps };
